function valueToHex2(value) {
  var hex = Number(value).toString(16).toUpperCase();
  return hex.length < 2 ? "0".concat(hex) : hex;
}
export var toHEX = function toHEX(red, green, blue) {
  return "#".concat(valueToHex2(red)).concat(valueToHex2(green)).concat(valueToHex2(blue));
};
export var toRGB = function toRGB(red, green, blue) {
  return "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")");
};
export var toRGBA = function toRGBA(red, green, blue, alpha) {
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")");
};

// Implementation inspired from
// https://stackoverflow.com/a/4235146/5801727
export var toHSVA = function toHSVA(red, green, blue, alpha) {
  var normalizedRed = red / 255;
  var normalizedGreen = green / 255;
  var normalizedBlue = blue / 255;
  var maximumValue = Math.max(normalizedRed, normalizedGreen, normalizedBlue);
  var minimumValue = Math.min(normalizedRed, normalizedGreen, normalizedBlue);
  var delta = maximumValue - minimumValue;
  var value = Math.round(maximumValue * 100);
  if (delta === 0) {
    // This means that this is gray
    var hue = 0;
    var _saturation = 0;
    return "hsva(".concat(hue, ", ").concat(_saturation, ", ").concat(value, ", ").concat(alpha, ")");
  }
  var saturation = Math.round(delta / maximumValue * 100);
  var deltaRed = ((maximumValue - normalizedRed) / 6 + delta / 2) / delta;
  var deltaGreen = ((maximumValue - normalizedGreen) / 6 + delta / 2) / delta;
  var deltaBlue = ((maximumValue - normalizedBlue) / 6 + delta / 2) / delta;
  switch (maximumValue) {
    case normalizedRed:
      {
        var _hue = Math.round(((deltaBlue - deltaGreen) * 360 + 360) % 360);
        return "hsva(".concat(_hue, ", ").concat(saturation, ", ").concat(value, ", ").concat(alpha, ")");
      }
    case normalizedGreen:
      {
        var _hue2 = Math.round(((1 / 3 + deltaRed - deltaBlue) * 360 + 360) % 360);
        return "hsva(".concat(_hue2, ", ").concat(saturation, ", ").concat(value, ", ").concat(alpha, ")");
      }
    case normalizedBlue:
      {
        var _hue3 = Math.round(((2 / 3 + deltaGreen - deltaRed) * 360 + 360) % 360);
        return "hsva(".concat(_hue3, ", ").concat(saturation, ", ").concat(value, ", ").concat(alpha, ")");
      }
  }
};
export var toHSBA = toHSVA;
//# sourceMappingURL=toString.js.map